export const es = {
  appName: "Horarios de Oración",
  tabs: {
    prayer: "Oración",
    qiblah: "Qibla",
    masjid: "Mezquita",
    settings: "Configuración",
    more: "Más"
  },
  prayer: {
    nextPrayer: "Próxima Oración",
    locating: "Determinando tu ubicación...",
    now: "Ahora",
    fajr: "Fajr",
    sunrise: "Amanecer",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    loading: "Cargando…",
    nextPrayerIn: "Próxima oración:",
    in: "en",
    today: "Hoy"
  },
  qiblah: {
    title: "Buscador de Qibla",
    subtitle: "Gira el dispositivo para alinear marcadores",
    compass: "Brújula",
    direction: "Dirección",
    gettingLocation: "Obteniendo ubicación…",
    locationPermissionRequired: "Se requiere permiso de ubicación.",
    refresh: "Actualizar"
  },
  masjid: {
    title: "Buscar una Mezquita",
    placeholder: "Buscar dirección o ciudad...",
    searching: "Buscando en Google Maps...",
    viewOnMaps: "Ver en Google Maps",
    noResults: "No se encontraron resultados cercanos.",
    local: "Local",
    search: "Buscar"
  },
  settings: {
    title: "Configuración",
    location: "Ubicación",
    manual: "Ubicación Manual",
    cityCountry: "Buscar ciudad...",
    latitude: "Latitud",
    longitude: "Longitud",
    calc: "Cálculo",
    calcMethod: "Método de Cálculo",
    asrMethod: "Método Asr",
    appearance: "Apariencia",
    lang: "Idioma",
    theme: "Tema",
    system: "Sistema",
    light: "Claro",
    dark: "Oscuro",
    save: "Guardar",
    adhanEnabled: "Habilitar Adhan",
    persistentNotifications: "Notificaciones Persistentes",
    ishaTime: "Hora Isha",
    fajrTime: "Hora Fajr",
    ishaDefault: "Predeterminado",
    fajrDefault: "Predeterminado",
    minAfterMaghrib: "Minutos después de Maghrib",
    minBeforeSunrise: "Minutos antes del Amanecer",
    minFromIsha: "Minutos desde Isha",
    minFromFajr: "Minutos desde Fajr",
    fixedTime: "Hora Fija",
    prayers: "Oraciones",
    muslimWorldLeague: "Liga Mundial Musulmana",
    standard: "Estándar"
  },
  more: {
    back: "Atrás",
    tasbih: "Tasbih",
    reset: "Reiniciar",
    count: "Contar",
    hijri: "Calendario Hijri",
    now: "Ahora",
    highlights: "Destacados del Mes",
    events: "Eventos y Noticias",
    ramadan: "INICIO DE RAMADÁN",
    eid: "EID AL-ADHA",
    duas: "Duas Diarias",
    kahf: "Sura Al-Kahf",
    listenFull: "ESCUCHAR SURA COMPLETA",
    pause: "PAUSAR",
    stats: "Estadísticas de Oración",
    statsDesc: "Intervalos de tiempo entre ventanas de oración diarias",
    fajrToMaghrib: "Fajr a Maghrib",
    dhuhrToAsr: "Dhuhr a Asr",
    sunriseToSunset: "Amanecer a Atardecer",
    fajrToSunrise: "Fajr a Amanecer",
    maghribToIsha: "Maghrib a Isha",
    appInfo: "Información de la App",
    zakat: "Calculadora de Zakat",
    zakatDesc: "Calcula tu Zakat (2.5% de la riqueza)",
    zakatTotal: "ZAKAT DEBIDO",
    cashSavings: "Efectivo / Ahorros",
    goldValue: "Valor del Oro",
    silverValue: "Valor de la Plata",
    nisabNote: "Asegúrate de que tu riqueza alcance el umbral de Nisab antes de pagar Zakat",
    inheritance: "Calculadora de Herencia",
    inheritanceDesc: "Calcula la distribución de herencia islámica",
    estateValue: "Valor del Patrimonio",
    selectHeirs: "Seleccionar Herederos",
    heirHusband: "Esposo",
    heirWife: "Esposa",
    heirFather: "Padre",
    heirMother: "Madre",
    heirSon: "Hijo",
    heirDaughter: "Hija",
    distribution: "DISTRIBUCIÓN",
    share: "parte",
    disclaimer: "Este es un cálculo simplificado. Consulta a un erudito para casos complejos.",
    namesOfAllah: "99 Nombres de Allah",
    nameNumber: "NOMBRE #",
    spiritualBenefit: "Beneficio Espiritual",
    weekDays: ["D", "L", "M", "X", "J", "V", "S"],
    monthly: "Horarios Mensuales",
    halalPlaces: "Lugares Halal",
    trains: "Trenes",
    less: "Menos",
    more: "Más...",
    downloadApp: "Descargar App Móvil",
    adjustHijri: "Ajustar Fecha Hijri",
    hijriCycle: "Ciclo Hijri",
    year: "Año",
    thisYear: "Este Año",
    tenYearOverview: "Visión General de 10 Años",
    ayahs: "Ayahs",
    ayah: "AYAH",
    fetchingAyahs: "Obteniendo Ayahs...",
    morning: "Mañana",
    evening: "Tarde",
    prayerStatistics: "Estadísticas de Oración",
    prayerIntervals: "Intervalos de tiempo de oración",
    daylightHours: "Horas de luz diurna",
    afternoonPeriod: "Período de la tarde",
    fullDaylight: "Luz del día completa",
    dawnPeriod: "Período del amanecer",
    eveningPeriod: "Período vespertino",
    errorLoading: "Error al cargar estadísticas",
    loadingStats: "Cargando estadísticas...",
    sons: "Hijos",
    daughters: "Hijas",
    searchHalal: "Buscar lugares halal",
    searching: "Buscando...",
    noResults: "No se encontraron resultados",
    viewOnMaps: "Ver en Mapas",
    selectStation: "Seleccionar Estación",
    favorites: "Favoritos",
    useCurrentLocation: "Usar Ubicación Actual",
    refresh: "Actualizar",
    loading: "Cargando...",
    dataSource: "Datos de Liikennevirasto Digital API. Licenciado bajo Creative Commons Attribution 4.0",
    appVersion: "Versión",
    appDescription: "Horarios de oración y utilidades islámicas para Finlandia"
  },
  trains: {
    useCurrentLocation: "Mi Ubicación",
    selectStation: "Seleccionar Estación",
    noTrainsFound: "No se encontraron trenes",
    time: "Hora",
    track: "Vía",
    train: "Tren",
    destination: "Destino",
    cancelled: "Cancelado"
  },
  ramadan: {
    title: "Ramadán 2026",
    expected: "Esperado:",
    date: "18-19 feb",
    daysLeft: "días restantes",
    today: "¡Hoy!",
    fastingHours: "Horas de Ayuno"
  }
};
